import { useEffect, useState } from "react";
import { fetchArtworks } from "@/lib/api";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Collection from "@/components/site/Collection";
import SacredWild from "@/components/site/SacredWild";
import Manifesto from "@/components/site/Manifesto";
import Studio from "@/components/site/Studio";
import Projects from "@/components/site/Projects";
import Exhibition from "@/components/site/Exhibition";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  const [collection, setCollection] = useState([]);
  const [sacred, setSacred] = useState([]);
  const [exhibition, setExhibition] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [col, sac, exh] = await Promise.all([
          fetchArtworks("collection"),
          fetchArtworks("sacred"),
          fetchArtworks("exhibition"),
        ]);
        if (mounted) {
          setCollection(col);
          setSacred(sac);
          setExhibition(exh);
        }
      } catch (e) {
        console.error("Failed to load artworks", e);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="relative bg-paper">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Collection artworks={collection} />
        <SacredWild artworks={sacred} />
        <Manifesto />
        <Studio />
        <Projects />
        <Exhibition artworks={exhibition} />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
